<template>
  <div>
    <AddCategory />
    <DownloadWorksheets />
  </div>
</template>

<script>
import AddCategory from "./add-category";
import DownloadWorksheets from "./download-worksheets";


export default {
  components: {
    AddCategory,
    DownloadWorksheets
  }
};
</script>